import React, { ComponentProps } from 'react';
import { TextInput as CarbonTextInput } from '@carbon/react';

export type TextInputProps = ComponentProps<typeof CarbonTextInput>;

export const TextInput = ({ children, ...props }: TextInputProps) => (
  <CarbonTextInput {...props}>{children}</CarbonTextInput>
);

TextInput.displayName = 'TextInput';
